import { Component, Input } from '@angular/core';
import FormRequest from '../common/formRequest';
import { FormBuilder, Validators } from '@angular/forms';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { LocalStorageService } from 'src/app/app-core/services/local-storage.service';

@Component({
  selector: 'app-form-request-default',
  templateUrl: './form-request-default.component.html',
  styleUrls: ['./form-request-default.component.scss'],
  providers: [LocalStorageService]
})
export class FormRequestDefaultComponent extends FormRequest {

  @Input() subject;

  private localStorageKey = 'new-request-descricao';

  constructor(
    public fb: FormBuilder,
    public fiscoService: FiscoService,
    private localStorageService: LocalStorageService,
  ) {
    super(fb, fiscoService);
    this._initForm();
    this.formChanges();
    this.getFromLocalStorage();
    this.watchDescricaoChanges();
  }

  private _initForm(): void {
    const formVariants = this.fb.group({
      SOL_Descricao: ["", Validators.required],
      termoAceito: [null, Validators.requiredTrue]
    });

    this.form.setControl("formVariants", formVariants);
  }

  private watchDescricaoChanges(): void {
    this.form.get('formVariants').get('SOL_Descricao').valueChanges.subscribe((value: string) => {
      this.localStorageService.set(this.localStorageKey, value);
    });
  }

  private getFromLocalStorage(): void {
    const storageData = this.localStorageService.get<string>(this.localStorageKey);

    if (storageData) {
      this.form.get('formVariants').get('SOL_Descricao').patchValue(storageData);
    }
  }

  public clearLocalStorage(): void {
    this.localStorageService.remove(this.localStorageKey);
  }

  get isRefisRequest(): boolean {
    return (this.subject || '').trim().toUpperCase() === 'SOLICITAÇÃO DE ADESÃO AO REFIS';
  }
}